import React, { Suspense, lazy } from 'react'
import ReactDOM from 'react-dom/client'
import './styles/main.scss'
import './scripts/init'
import './scripts/quillConfig'
import PagingApp from '../Features/Paging/PagingApp'
import ForumQandA from 'Features/Community/ForumQandAPage/ForumQandA'
import Thread from 'Features/Community/ForumQandAPage/Thread'
import CreateNewThread from 'Features/Community/ForumQandAPage/CreateNewThread'
import PublicationLoader from 'Features/Publication/PublicationPage/PublicationModal/PublicationLoader'
import WorkroomsListOverview from 'Features/Community/CommunityWorkRoomPage/WorkroomsListOverview'
import Workroom from 'Features/Community/CommunityWorkRoomPage/Workroom'
import CreateNewWorkroom from 'Features/Community/CommunityCreateWorkRoomPage/CreateNewWorkroom'
import ProfilePage from 'Features/Community/ViewProfilePage/ProfilePage'
import QuizApp from '../Features/FoodHabit/Components/QuizApp'
import ListingApp from '../Features/Listing/Components/ListingApp'
import NewsLetterAdminApp from '../Features/News/NewsletterAdminApp'
import MembersListingPage from 'Features/Community/MembersPage/MembersListingPage'
import MagnifyImage from 'Features/Blocks/MagnifyImageBlock/MagnifyImage'
import CommunityDashboard from 'Features/Community/CommunityDashboard/CommunityDashboard'
import 'Frontend/i18n/config'
import { applyAmChartsLicense } from './amcharts-license'
import MembershipAdminApp from '../Features/VirusLab/MembershipAdminApp.tsx'

applyAmChartsLicense()

const pagingContainer = document.querySelector('#paging-container')
const forumQandA = document.querySelector('#forumQandA')
const thread = document.querySelector('#thread')
const createNewThread = document.querySelector('#createNewThread')
const publicationModal = document.querySelector('#publicationModal')
const workroomOverview = document.querySelector('#workroomOverview')
const workroom = document.querySelector('#workroom')
const createNewWorkroom = document.querySelector('#createNewWorkroom')
const profilePage = document.querySelector('#profilePage')
const quizContainer = document.querySelector('#quizContainer')
const listingContainer = document.querySelector('#listingContainer')
const membersListingPage = document.querySelector('#membersListingPage')
const newsletterAdminContainer = document.querySelector('#newsletterAdminContainer')
const newsListContainer = document.querySelector('#news-list')
const registerUser = document.querySelector('#registerUser')
const NewsList = lazy(() => import('../Features/News/Components/NewsList'))
const RegisterUser = lazy(() => import('../Features/Community/Account/RegisterUser'))
const MagnifyImageContainer = document.querySelector('#magnifyImage')
const communityDashboard = document.querySelector('#communityDashboard')
const membershipAdminContainer = document.querySelector('#approveUserMembershipAdminContainer')

//Shared

if (pagingContainer) {
  const noOfPages = parseInt(pagingContainer.getAttribute('data-no-of-pages') || '0', 10)
  const activePage = parseInt(pagingContainer.getAttribute('data-active-page') || '1', 10)

  ReactDOM.createRoot(pagingContainer).render(
    <React.StrictMode>
      <Suspense>
        <PagingApp noOfPages={noOfPages} activePage={activePage} />
      </Suspense>
    </React.StrictMode>,
  )
}

if (MagnifyImageContainer) {
  const imageUrl = MagnifyImageContainer.getAttribute('data-magnifyimage-url')
  const alt = MagnifyImageContainer.getAttribute('data-magnifyimage-alt')
  const title = MagnifyImageContainer.getAttribute('data-magnifyimage-title')
  const id = MagnifyImageContainer.getAttribute('data-magnifyimage-id')
  const buttonText = MagnifyImageContainer.getAttribute('data-magnifyimage-button-text')
  const closeButtonText = MagnifyImageContainer.getAttribute('data-magnifyimage-close-button-text')
  if (imageUrl && id) {
    ReactDOM.createRoot(MagnifyImageContainer).render(
      <React.StrictMode>
        <Suspense>
          <MagnifyImage
            blockId={id}
            title={title as string}
            imageSrc={imageUrl}
            altText={alt as string}
            buttonText={buttonText as string}
            closeButtonText={closeButtonText as string}
          />
        </Suspense>
      </React.StrictMode>,
    )
  }
}

if (newsListContainer) {
  const activePage = parseInt(newsListContainer.getAttribute('data-active-page') || '1', 10)
  const hitsPerPage = parseInt(newsListContainer.getAttribute('data-hits-per-page') || '1', 10)
  const showPaging = newsListContainer.getAttribute('data-show-paging') === 'true'
  const useMultiFilter = newsListContainer.getAttribute('data-use-multifilter') === 'true'
  const baseFilter = newsListContainer.getAttribute('data-base-filter') ?? ''
  const enableFilter = newsListContainer.getAttribute('data-enable-category-filter') === 'true'

  ReactDOM.createRoot(newsListContainer).render(
    <React.StrictMode>
      <Suspense>
        <NewsList
          baseFilter={baseFilter}
          activePage={activePage}
          hitsPerPage={hitsPerPage}
          showPaging={showPaging}
          useMultiFilter={useMultiFilter}
          enableFilter={enableFilter}
        />
      </Suspense>
    </React.StrictMode>,
  )
}

//Mainweb
if (quizContainer) {
  ReactDOM.createRoot(quizContainer).render(
    <React.StrictMode>
      <Suspense>
        <QuizApp foodHabitStartPageId={quizContainer.getAttribute('data-contentid') ?? ''} />
      </Suspense>
    </React.StrictMode>,
  )
}

if (publicationModal) {
  ReactDOM.createRoot(publicationModal!).render(
    <React.StrictMode>
      <Suspense>
        <PublicationLoader publicationId={publicationModal.getAttribute('data-contentid') ?? ''} />
      </Suspense>
    </React.StrictMode>,
  )
}

if (listingContainer) {
  ReactDOM.createRoot(listingContainer!).render(
    <React.StrictMode>
      <Suspense>
        <ListingApp listingPageId={listingContainer.getAttribute('data-contentid') ?? ''}></ListingApp>
      </Suspense>
    </React.StrictMode>,
  )
}

//Livstecknet

if (forumQandA != null) {
  ReactDOM.createRoot(forumQandA!).render(
    <React.StrictMode>
      <Suspense>
        <ForumQandA pageName={forumQandA.getAttribute('data-page-name')} />
      </Suspense>
    </React.StrictMode>,
  )
}

if (thread != null) {
  ReactDOM.createRoot(thread!).render(
    <React.StrictMode>
      <Suspense>
        <Thread listingpageUrl={thread.getAttribute('data-listingpage-url')} />
      </Suspense>
    </React.StrictMode>,
  )
}

if (createNewThread != null) {
  ReactDOM.createRoot(createNewThread!).render(
    <React.StrictMode>
      <Suspense>
        <CreateNewThread forumListingPageUrl={createNewThread.getAttribute('data-forum-page-url') as string} />
      </Suspense>
    </React.StrictMode>,
  )
}

if (workroomOverview) {
  ReactDOM.createRoot(workroomOverview!).render(
    <React.StrictMode>
      <Suspense>
        <WorkroomsListOverview
          createUrl={workroomOverview.getAttribute('data-create-url')}
          pageName={workroomOverview.getAttribute('data-page-name')}
        />
      </Suspense>
    </React.StrictMode>,
  )
}

if (workroom) {
  ReactDOM.createRoot(workroom!).render(
    <React.StrictMode>
      <Suspense>
        <Workroom
          workroomName={workroom.getAttribute('data-workroom-name') as string}
          listingUrl={workroom.getAttribute('data-workroom-listing-url') as string}
          isHidden={workroom.getAttribute('data-is-hidden') as string}
        />
      </Suspense>
    </React.StrictMode>,
  )
}

if (createNewWorkroom != null) {
  ReactDOM.createRoot(createNewWorkroom!).render(
    <React.StrictMode>
      <Suspense>
        <CreateNewWorkroom />
      </Suspense>
    </React.StrictMode>,
  )
}

if (profilePage != null) {
  ReactDOM.createRoot(profilePage!).render(
    <React.StrictMode>
      <Suspense>
        <ProfilePage
          userId={profilePage.getAttribute('data-user-id') as string}
          hasEditAccess={profilePage.getAttribute('data-has-edit-access') as string}
          showMyWorkrooms={profilePage.getAttribute('data-show-my-workrooms') as string}
        />
      </Suspense>
    </React.StrictMode>,
  )
}

if (membersListingPage != null) {
  ReactDOM.createRoot(membersListingPage!).render(
    <React.StrictMode>
      <Suspense>
        <MembersListingPage />
      </Suspense>
    </React.StrictMode>,
  )
}

if (registerUser != null) {
  ReactDOM.createRoot(registerUser!).render(
    <React.StrictMode>
      <Suspense>
        <RegisterUser membershipTermsLink={registerUser.getAttribute('data-membership-link') as string} />
      </Suspense>
    </React.StrictMode>,
  )
}

if (communityDashboard != null) {
  ReactDOM.createRoot(communityDashboard!).render(
    <React.StrictMode>
      <Suspense>
        <CommunityDashboard
          isAdmin={communityDashboard.getAttribute('data-is-current-user-admin') as string}
          isModerator={communityDashboard.getAttribute('data-is-current-user-moderator') as string}
        />
      </Suspense>
    </React.StrictMode>,
  )
}

if (newsletterAdminContainer != null) {
  ReactDOM.createRoot(newsletterAdminContainer!).render(
    <React.StrictMode>
      <Suspense>
        <NewsLetterAdminApp env={newsletterAdminContainer.getAttribute('data-env') || 'production'} />
      </Suspense>
    </React.StrictMode>,
  )
}

if (membershipAdminContainer != null) {
  ReactDOM.createRoot(membershipAdminContainer!).render(
    <React.StrictMode>
      <Suspense>
        <MembershipAdminApp env={membershipAdminContainer.getAttribute('data-env') || 'production'} />
      </Suspense>
    </React.StrictMode>,
  )
}

//#region Community News

const CommunityNewsListing = lazy(() => import('../Features/Community/CommunityNews/CommunityNewsListingPage/CommunityNewsListing.tsx'))
const communityNewsListContainer = document.querySelector('#communityNewsListContainer')
const communityPageId = communityNewsListContainer?.getAttribute('data-content-id') as string

if (communityNewsListContainer != null) {
  ReactDOM.createRoot(communityNewsListContainer!).render(
    <React.StrictMode>
      <Suspense>
        <CommunityNewsListing pageId={communityPageId} />
      </Suspense>
    </React.StrictMode>,
  )
}

//#endregion

//#region Comments

const CommentsContainer = lazy(() => import('../Features/Components/Comments/CommentsContainer.tsx'))
const communityNewsCommentsContainer = document.querySelector('#communityCommentsContainer')
const newsPageId = communityNewsCommentsContainer?.getAttribute('data-content-id')

if (communityNewsCommentsContainer != null) {
  ReactDOM.createRoot(communityNewsCommentsContainer!).render(
    <React.StrictMode>
      <Suspense>
        <CommentsContainer contentId={newsPageId as string} />
      </Suspense>
    </React.StrictMode>,
  )
}

//#endregion

//#region Community blog

const CommunityBlogListing = lazy(
  () => import('../Features/Community/CommunityBlog/CommunityBlogListingPage/CommunityBlogListing.tsx'),
)
const communityBlogContainer = document.querySelector('#blog-list-container')
const blogListingPageContentId = communityBlogContainer?.getAttribute('data-content-id')

if (communityBlogContainer != null) {
  ReactDOM.createRoot(communityBlogContainer!).render(
    <React.StrictMode>
      <Suspense>
        <CommunityBlogListing contentId={blogListingPageContentId as string} />
      </Suspense>
    </React.StrictMode>,
  )
}

const CreateBlogPost = lazy(
  () => import('../Features/Community/CommunityBlog/CommunityBlogListingPage/CreateBlogPost.tsx'),
)
const createBlogContainer = document.querySelector('#create-blog-post')
const blogListingPageId = createBlogContainer?.getAttribute('data-content-id')
const returnUrl = createBlogContainer?.getAttribute('data-return-url')

if (createBlogContainer != null) {
  ReactDOM.createRoot(createBlogContainer!).render(
    <React.StrictMode>
      <Suspense>
        <CreateBlogPost pagelistingId={blogListingPageId as string} listingPageReturnUrl={returnUrl as string} />
      </Suspense>
    </React.StrictMode>,
  )
}

//#endregion

const CommunityStartpage = lazy(() => import('../Features/Community/StartPage/CommunityStartPage.tsx'))
const communityStartPage = document.querySelector('#communityStartPage')
const communityStartPageId = communityStartPage?.getAttribute('data-content-id')

if (communityStartPage != null) {
  ReactDOM.createRoot(communityStartPage!).render(
    <React.StrictMode>
      <Suspense>
        <CommunityStartpage pageId={communityStartPageId as string} />
      </Suspense>
    </React.StrictMode>,
  )
}
